var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.042,
    height: 33.187,
    viewBox: "0 0 42.042 33.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-187.407 -988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_four_squares_310072",
    "data-name": "noun_four squares_310072",
    transform: "translate(194.916 985.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(2.2 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M11.262,11.562H2.2V2.5h9.062Zm-8.06-1H10.26V3.5H3.2Z",
    transform: "translate(-2.2 -2.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(2.2 13.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M11.262,64.126H2.2V55h9.062Zm-8.06-1H10.26V56H3.2Z",
    transform: "translate(-2.2 -55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(13.522 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M64.362,11.562H55.3V2.5h9.062Zm-8.06-1H63.36V3.5H56.3Z",
    transform: "translate(-55.3 -2.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(13.522 13.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M64.362,64.126H55.3V55h9.062Zm-8.06-1H63.36V56H56.3Z",
    transform: "translate(-55.3 -55)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M3.5-.041C1.9-.041.649.784.649,2.258a1.685,1.685,0,0,0,.572,1.331A5.2,5.2,0,0,0,3.465,4.4c1.694.319,2.211.737,2.211,1.474,0,.924-.726,1.43-1.991,1.43-1.309,0-2.288-.66-2.288-1.892H.407c0,1.826,1.364,2.772,3.245,2.772a3.847,3.847,0,0,0,2.156-.605,2.019,2.019,0,0,0,.913-1.738c0-1.32-.891-1.914-2.508-2.266C3.894,3.512,3.454,3.424,3,3.3c-.682-.187-1.309-.44-1.309-1.122,0-.858.638-1.342,1.76-1.342A1.715,1.715,0,0,1,5.4,2.445h.99C6.347.85,5.236-.041,3.5-.041Zm6.7,2.222A2.74,2.74,0,0,0,7.524,5.118a2.714,2.714,0,0,0,2.728,3.014A2.3,2.3,0,0,0,12.683,6.2h-.924a1.362,1.362,0,0,1-1.474,1.111A1.666,1.666,0,0,1,8.514,5.5V5.437h4.257v-.11C12.771,3.5,11.858,2.181,10.2,2.181ZM8.514,4.612a1.616,1.616,0,0,1,1.617-1.606,1.638,1.638,0,0,1,1.65,1.606Zm7.6-2.431c-1.749,0-2.684,1.276-2.684,3.047a2.584,2.584,0,0,0,2.662,2.9A2.363,2.363,0,0,0,18.6,5.921h-.957a1.463,1.463,0,0,1-1.562,1.386c-1.045,0-1.661-.836-1.661-2.079,0-1.408.594-2.222,1.771-2.222A1.328,1.328,0,0,1,17.6,4.139h.968A2.168,2.168,0,0,0,16.115,2.181ZM20.009.608v1.7h-.968v.825h.968v3.6c0,.946.264,1.265,1.3,1.265h.77V7.175h-.429c-.473,0-.7-.022-.7-.473V3.138h1.133V2.313H20.944V.608ZM23.166.146V1.29H24.1V.146Zm0,2.167V8H24.1V2.313Zm4.84-.132a2.7,2.7,0,0,0-2.761,2.981,2.768,2.768,0,1,0,5.522,0A2.7,2.7,0,0,0,28.006,2.181ZM26.235,5.162c0-1.364.77-2.156,1.76-2.156,1.034,0,1.782.825,1.782,2.156s-.748,2.145-1.771,2.145C26.961,7.307,26.235,6.449,26.235,5.162Zm8.382-2.981a1.971,1.971,0,0,0-1.848,1.034h-.022v-.9h-.88V8H32.8V4.755a1.592,1.592,0,0,1,1.672-1.749A1.072,1.072,0,0,1,35.64,4.161V8h.935V4.216C36.575,2.907,35.992,2.181,34.617,2.181Zm5.258,0c-1.243,0-2.134.616-2.134,1.617,0,.814.473,1.32,1.947,1.628a4.243,4.243,0,0,1,1.419.429.7.7,0,0,1,.352.605c0,.561-.473.847-1.375.847-.946,0-1.507-.4-1.529-1.1H37.62c.055,1.276.968,1.925,2.409,1.925,1.408,0,2.42-.605,2.42-1.793,0-.9-.616-1.331-1.716-1.584l-.825-.187c-.77-.176-1.177-.4-1.177-.836,0-.462.462-.726,1.21-.726s1.265.341,1.32.946v.011H42.2C42.119,2.775,41.4,2.181,39.875,2.181Z",
    transform: "translate(187 1013)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionImage);
export default __webpack_public_path__ + "static/media/sectionImage.28fd088d8f50324a247eec0df8f02edf.svg";
export { ForwardRef as ReactComponent };